var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/utility-registry-image.j2"] = require( "header/utility-registry-image.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-registry.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/utility-registry.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId") == "an-us") {
output += "<a ";
output += runtime.suppressValue((lineno = 4, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["top_nav","Registry"])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 4, colno = 52, runtime.callWrap(t_4, "genericUrl", context, [(lineno = 4, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["header_nav-registry-url"]))])), env.opts.autoescape);
output += "\" class=\"c-brand-link c-utility__a c-utility-toggle__title c-brand-navigation__link\" data-qa-header-registry>\n\n    \t";
env.getTemplate("header/utility-registry-image.j2", false, "core/templates/header/utility-registry.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    \t";
output += runtime.suppressValue((lineno = 8, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-registry"])), env.opts.autoescape);
output += "\n\n    </a>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-registry.j2"] , dependencies)